import { useLaravelApi } from 'data/api/laravel.api';
import { toUser } from 'data/dto/user.dto';
import { User, UserHttp } from 'data/models/user.interface';
import { useStorage } from 'plugins/storage';

export const TOKEN_SESSION_NAME = 'TOKEN_SESSION_NAME';

const PARAM_SCUD_API_TOKEN = 'scud_api_token';

export const useAuthService = () => {
  const storage = useStorage();
  const tokenSessionName = TOKEN_SESSION_NAME;
  const { get } = useLaravelApi();

  const getToken = (): string | null => {
    return storage.get<string>(tokenSessionName);
  };

  const setToken = (token: string): void => {
    return storage.set(tokenSessionName, token, true);
  };

  const containsApiToken = (location: string): boolean => {
    return location.includes(PARAM_SCUD_API_TOKEN);
  };

  const extractApiToken = (url: URL): string | null => {
    return url.searchParams.get(PARAM_SCUD_API_TOKEN);
  };

  const updateTokenAndRedirect = (url: URL, apiToken: string): void => {
    setToken(apiToken);
    url.searchParams.delete(PARAM_SCUD_API_TOKEN);
    window.location.href = url.toString();
  };

  const initializeToken = (): void => {
    const location = window.location.toString();
    if (!containsApiToken(location)) {
      return;
    }

    const url = new URL(location);
    const apiToken = extractApiToken(url);

    if (apiToken) {
      updateTokenAndRedirect(url, apiToken);
    }
  };

  const getMe = async (): Promise<User> => {
    const loginUri = `${process.env.VITE_APP_LOGIN_URL}?redirect_uri=${window.location.href}`;

    if (!getToken()) {
      window.location.href = loginUri;
    }

    const { data, error } = await get<{ data: UserHttp }>('/auth/me');

    if (error) {
      window.location.href = loginUri;
    }

    return toUser(data?.data || {});
  };

  return {
    initializeToken,
    getMe,
  };
};
